import React from "react";
import ReactDom from 'react-dom'
import App from "./App";

const container = document.getElementById("App")

ReactDom.render(<App />, container)